import { useUserContext } from '@issuemanager/apps/client/contexts';

export function useAdmin() {
  const { userRoles } = useUserContext();
  return userRoles?.isAdmin ?? false;
}
